import * as S from './IndustrialCaseDetailPage.styles';

/**
 * ### IndustrialCasePublicationMetaLabels
 *
 * Label for the publication date.
 */
export type IndustrialCasePublicationMetaLabels = {
  readonly publishedAt: string;
};

/**
 * ### IndustrialCasePublicationMeta
 *
 * States when a case was published.
 *
 * The last-verified date is deliberately not shown to readers. It still feeds
 * the sitemap `lastmod` and the structured data `dateModified`, where it tells
 * crawlers when the figures were last checked.
 *
 * The date is recommended, so the line disappears when it is not set. It is
 * rendered as the authored
 * `YYYY-MM-DD` string inside a `<time>` rather than formatted per locale: the
 * value is a plain calendar day with no timezone, and reformatting it on the
 * client is what makes a server and client render disagree.
 *
 * @param props The dates as stored on the document, and their labels
 * @returns The publication line, or nothing when no date is recorded
 */
export function IndustrialCasePublicationMeta({
  publishedAt,
  labels,
}: {
  publishedAt: string;
  labels: IndustrialCasePublicationMetaLabels;
}) {
  if (!publishedAt) return null;

  return (
    <p className={S.publicationMeta}>
      <span>
        {labels.publishedAt} <time dateTime={publishedAt}>{publishedAt}</time>
      </span>
    </p>
  );
}
